import { HomeSlideRepository } from '../../domain/repositories/home-slide.repository';
import { HomeSlideEntity } from '../../domain/entities/home-slide.entity';

export class ToggleHomeSlideStatusUseCase {
  constructor(private readonly homeSlideRepository: HomeSlideRepository) {}

  public async execute(id: string, newStatus: boolean): Promise<HomeSlideEntity> {
    return this.homeSlideRepository.toggleSlideStatus(id, newStatus);
  }
}
